import { FieldSettings, NumericFilter, TextFilter } from '@progress/kendo-react-data-tools'
import { RebateFilterKey } from 'api/Trading-Accounts/Types/IntroducingBrokerRebates'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { RebateApprovalTypeFilter } from './RebateApprovalTypeFilter'
import { RebatePeriodFilter } from './RebatePeriodFilter'
import { YesNoFilter } from './YesNoFilter'

export const getIBRebatesGroupFilters = (): FieldSettings[] => [
  {
    name: RebateFilterKey.name,
    label: 'Group Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: RebateFilterKey.rebateApprovalType,
    label: 'Rebate Approval Type',
    filter: RebateApprovalTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: RebateFilterKey.rebatePeriod,
    label: 'Rebate Period',
    filter: RebatePeriodFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: RebateFilterKey.amount,
    label: 'Amount',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gtOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gteOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.ltOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.lteOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
    ],
  },
  {
    name: RebateFilterKey.tradingAccountsCount,
    label: 'Trading Accounts Count',
    filter: NumericFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gteOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gtOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.lteOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.ltOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: RebateFilterKey.isDefault,
    label: 'Default Group',
    filter: YesNoFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
    ],
  },
]
